<template>
  <div v-if="showCheckbox" class="join-partnership-field-wrapper">
    <checkbox-input :checkbox-id="calculatedInputId" :initial-value="value" :input-name="calculatedInputName"
                    :label="label" :show-label="showLabel" :validation-errors="validationErrors"
                    @change="checkboxChange" @focus="$emit('focus')" />
  </div>
  <div v-else />
</template>

<script>
import CheckboxInput from './checkbox-input'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { CheckboxInput },

  mixins: [ WithInputIdAndName ],

  props: {
    displayOptIn: {
      type: Boolean,
      required: true
    },

    entityName: {
      type: String,
      required: true
    },

    initialValue: {
      type: Boolean,
      required: false
    },

    inputId: {
      type: String,
      required: false,
      default: null
    },

    inputName: {
      type: String,
      required: false,
      default: null
    },

    joinPartnershipDefault: {
      type: Boolean,
      required: true
    },

    joinListSuppressed: {
      type: Boolean,
      required: true
    },

    label: {
      type: String,
      required: false
    },

    partnershipId: {
      type: Number,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    return {
      fieldName: `partnership-opt-in-${this.partnershipId}`,
      value: this.computeInitialValue()
    }
  },

  computed: {
    showCheckbox() {
      return this.displayOptIn && !this.joinListSuppressed
    }
  },

  mounted() {
    // Need to emit so that if the user submits the form without checking/unchecking the box,
    // the parent component will have the correct values for this fields
    this.emitValue()
  },

  methods: {
    checkboxChange(value) {
      this.value = value
      this.emitValue()
    },

    computeInitialValue() {
      if (this.displayOptIn) {
        if (this.joinListSuppressed) {
          return false
        }
        else {
          if (this.initialValue === undefined) {
            return this.joinPartnershipDefault
          } else {
            return this.initialValue
          }
        }
      }
      else {
        return true
      }
    },

    emitValue() {
      this.$emit('changed', this.value)
    }
  }
}
</script>
